export default __webpack_public_path__ + "static/cmatic-logo-38609ee68eb93b33966e8ea3a7605a46.svg";